<template>
    <div>
        <div class="modal" tabindex="-1" ref="confirmModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ title }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body" v-html="content">
                    </div>
                    <div v-if="noConfirm" class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" @click="confirm(false)"><i class="fas fa-check me-2"></i>Ok</button>
                    </div>
                    <div v-else class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" @click="confirm(false)"><i class="fas fa-times me-2"></i>Cancel</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="confirm(true)"><i class="fas fa-check me-2"></i>Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Modal} from 'bootstrap';

export default {
    mounted() {
        this.modal = new Modal(this.$refs.confirmModal, {})
    },

    props: {
        noConfirm: {
            type: Boolean,
            default: false,
        }
    },

    methods: {
        show: function(data = {}) {
            this.content = data.content ?? this.content;
            this.title = data.title ?? this.title;
            this.callback = data.callback ?? this.callback;
            this.declined = data.declined ?? this.declined;

            this.modal.show();
        },
        hide: function() {
            this.modal.hide();
        },
        confirm: function(state=false) {
            this.modal.hide();
            if (state) {
                this.callback();
            } else {
                this.declined();
            }
        },
    },

    data() {
        return {
            modal: null,

            content: 'No content',
            title: 'Confirmation',
            callback: function() { console.log('No callback set') },
            declined: function() { console.log('No declined callback set') },
        }
    }
}
</script>